import apiClient from '../axios';

export default {
    getMaterialporLeccion(id) {
        return apiClient.get(`/materiales/leccion/${id}`);
    },

};